import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { formatMoney } from '../../util/currency';
import { propTypes } from '../../util/types';
import { resolveLatestProcessName, getProcess } from '../../transactions/transaction';

import css from './OrderBreakdown.module.css';
import { types as sdkTypes } from '../../util/sdkLoader';
import { calculateAmountIfCustomerDispute } from './OrderBreakdown';

const { Money } = sdkTypes;
const STIPE_COMMISSION = -337; // in cents
const PERCENTS = 100;
const STRIPE_FEE = 2.9;
const ADDITIONAL_STRIPE_FEE = 30;
const PROVIDERS_COMMISSION = 10;
const CUSTOMERS_COMMISSION = 15;

const DISPUTED_TRANSITIONS = [
  'transition/accept-provider-dispute-with-50-refund',
  'transition/decline-provider-dispute-with-full-refund-to-customer',
];

const calculateStripeFee = payinTotal => {
  const fee = (payinTotal * STRIPE_FEE) / PERCENTS + ADDITIONAL_STRIPE_FEE;
  return fee.toFixed();
};



const LineItemTotalPrice = props => {
  const { transaction, isProvider, intl, isProviderCancel, isCustomerCancel, lineItems } = props;
  const processName = resolveLatestProcessName(transaction?.attributes?.processName);
  if (!processName) {
    return null;
  }
  const process = getProcess(processName);
  const isCompleted = process.isCompleted(transaction?.attributes?.lastTransition);
  const isRefunded = process.isRefunded(transaction?.attributes?.lastTransition);
  const isPartialRefund = !!transaction?.attributes?.metadata?.partialRefundData || false;

  let payoutTotalWithRefund, payinTotalWithRefund;
  let totalForProvider = 0;
  let totalForCustomer = 0;
  const payinTotal = transaction.attributes.payinTotal.amount;
  const stripeFee = calculateStripeFee(payinTotal);
  const customerCommission = transaction.attributes.lineItems.find(lineItem => lineItem.code === 'line-item/customer-commission');

  if (isPartialRefund) {
    const partialRefundAmount = transaction.attributes.metadata.partialRefundData.amount;

    // const itemPrice = transaction.attributes.lineItems.find(lineItem => lineItem.code === 'line-item/night' || lineItem.code === 'line-item/day' || lineItem.code === 'line-item/hour' || lineItem.code === 'line-item/item');
    // const isProviderDispute = DISPUTED_TRANSITIONS.includes(transaction.attributes?.lastTransition)
    const serviceLineItems = lineItems?.filter(
      l =>  l.code !== 'line-item/hour' && l.code !== 'line-item/item' && l.code !== 'line-item/customer-commission' && l.code !== 'line-item/provider-commission' && !l.reversal
    );

    const servicePriceArray = serviceLineItems.map(item => item.lineTotal.amount);
    const servicePriceSum = servicePriceArray.reduce((partialSum, a) => partialSum + a, 0);



    const customLineItems = calculateAmountIfCustomerDispute(servicePriceSum, partialRefundAmount);
    totalForCustomer = customLineItems?.customer?.totalForCustomer;
    totalForProvider = servicePriceSum === partialRefundAmount || partialRefundAmount > servicePriceSum ? -stripeFee : customLineItems?.provider?.totalForProvider;

  }

  let providerTotalMessageId = 'OrderBreakdown.providerTotalDefault';
  if (isCompleted) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalReceived';
  } else if (isRefunded) {
    providerTotalMessageId = 'OrderBreakdown.providerTotalRefunded';
  }

  const totalLabel = isProvider ? (
    <FormattedMessage id={providerTotalMessageId} />
  ) : (
    <FormattedMessage id="OrderBreakdown.total" />
  );

  let totalPrice;


  if (isProvider) {
    if (isPartialRefund) {
      if(isProviderCancel) {
        totalPrice = new Money(-stripeFee, 'USD')
      }
      else if (isCustomerCancel) {
        totalPrice = new Money(0, 'USD');
      }
      else {
        totalPrice = new Money(totalForProvider, 'USD');
      }
    } else {
      totalPrice = transaction.attributes.payoutTotal;
    }
  } else {
    if (isPartialRefund) {
      if(isProviderCancel) {
        totalPrice = new Money(0, 'USD')
      }
      else if (isCustomerCancel) {
        totalPrice = customerCommission.lineTotal
      }
      else {
        totalPrice = new Money(totalForCustomer, 'USD');
      }

    } else {
      totalPrice = transaction.attributes.payinTotal;
    }
  }

  const formattedTotalPrice = formatMoney(intl, totalPrice);

  return (
    <>
      <hr className={css.totalDivider} />
      <div className={css.lineItemTotal}>
        <div className={css.totalLabel}>{totalLabel}</div>
        <div className={css.totalPrice}>{formattedTotalPrice}</div>
      </div>
    </>
  );
};

LineItemTotalPrice.propTypes = {
  transaction: propTypes.transaction.isRequired,
  isProvider: bool.isRequired,
  intl: intlShape.isRequired,
};

export default LineItemTotalPrice;
